<template>
  <div class="padding-block-1 limiter">

    <div class="margin-bottom-1">
      <h2 class="text-5 tw-text-blue tw-font-bold">
        Bienvenue !
      </h2>
      <p class="text-2">
        Cet espace vous permet d'enregistrer vos événements organisés dans le cadre de l'Enfance des arts. Ces derniers seront mis en ligne après une première validation de notre part. Vous pouvez à tout moment y apporter des modifications. Vous avez des questions à propos de l'enregistrement de vos événements ? N'hésitez pas à nous contacter à <span class="tw-text-pink">contact@enfancedesarts.com</span>
      </p>
    </div>

    <div class="tw-flex tw-flex-col md:tw-flex-row md:tw-items-center tw-justify-between tw-gap-12 tw-mb-48">
      <h2 class="text-3 tw-font-bold">Mes événements</h2>
      <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-8 tw-items-end md:tw-items-center ">
        <DashLink link="/nouveau-evenement" icon="mdi-pen-plus" texte="Nouvel événement"/>
        <Logout/>
      </div>

    </div>

    <div>
      <EventsListing v-if="mesEvenements && mesEvenements.length > 0" :events="mesEvenements" :edit="true" @deleted="deleteEvent"/>
      <div class="tw-w-full tw-flex tw-justify-center tw-py-24" v-else-if="mesEvenements && mesEvenements.length === 0">
        <p class="text-2 tw-font-bold tw-text-center">Vous n'avez pas encore d'événements</p>
      </div>
      <v-progress-linear
          v-else
          class="tw-w-96"
          color="primary accent-4"
          rounded
          height="6"
          indeterminate
      ></v-progress-linear>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "../store";

import EventsListing from "../components/Events/EventsListing";
import DashLink from "../components/Account/DashLink";
import Logout from "../components/Account/Logout";

export default {
  name: "MesEvenements",
  components: {Logout, DashLink, EventsListing},
  data() {
    return {
      mesEvenements : null
    }
  },
  async created() {

    if(!store.state.token) {
      window.location.replace('/connexion');
    }

    if(store.state.token && store.state.user) {
      this.getEvents()
    } else {
      await store.dispatch('AutoLogin').then( () => {
        this.getEvents()
      })
    }

  },
  methods : {
    getEvents() {
      const user = store.state.user
      let userID = user.ID
      let username = 'wpAppKey'
      let application_password = 'rNM7 k9MU Fak5 ENAv zQ2V 1azQ'
      console.log(userID)
      axios.get(store.state.baseJson+`/wp/v2/evenement?author=${userID}&status=*` , {
        headers : {
          'Authorization': 'Basic ' + btoa(`${username}` + ":" + `${application_password}`),
        }
      }).then( (res) => {
        this.filterEvents(res.data)
      }).catch( (error) => {
        console.log(error)
      })
    },
    filterEvents(events) {

      const validEvents = events.filter( (event) => {
        return event.status === 'pending' || event.status === 'publish'
      })
      this.mesEvenements = validEvents
    },

    deleteEvent(id) {
      var deletedEvent = this.mesEvenements.findIndex(event => {
        return event.id === id
      })
      this.mesEvenements.splice(deletedEvent , 1)
    }
  },
}
</script>

<style scoped>

</style>